import * as classNames from 'classnames'
import * as React from 'react'

export class Input extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      valid: true
    }
  }

  public render() {
    const { value } = this.props

    const { valid } = this.state

    const classes = classNames('rounded p1', {
      'border-light-grey4': valid,
      'border-red focus-red': !valid
    })
    return <input className={classes} type='text' value={value} onChange={this.handleChange} />
  }

  public isValid = () => {
    const { value, validate } = this.props
    if (!validate) {
      return true
    }

    return validate(value)
  }

  private handleChange = (e: any) => {
    const { validate, onChange } = this.props
    const val = e.target.value || ''
    if (validate && !validate(val)) {
      this.setState({ valid: false }, () => {
        onChange(val)
      })
    } else {
      this.setState({ valid: true }, () => {
        onChange(val)
      })
    }
  }
}

export class TextArea extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      valid: true
    }
  }

  public render() {
    const { value } = this.props

    const { valid } = this.state

    const classes = classNames('rounded p1', {
      'border-light-grey4': valid,
      'border-red focus-red': !valid
    })
    return <textarea className={classes} value={value} onChange={this.handleChange} />
  }

  public isValid = () => {
    const { value, validate } = this.props
    if (!validate) {
      return true
    }

    return validate(value)
  }

  private handleChange = (e: any) => {
    const { validate, onChange } = this.props
    const val = e.target.value || ''
    if (validate && !validate(val)) {
      this.setState({ valid: false }, () => {
        onChange(val)
      })
    } else {
      this.setState({ valid: true }, () => {
        onChange(val)
      })
    }
  }
}

export class FormComponent extends React.Component<any, any> {
  private fieldRefs: { [x: string]: any } = {}

  // TODO: figure out a better way. Currently this won't
  // work for a field until more than 1 char has been entered.
  // That's probably ok, but it should be noted
  public fieldsValid = () => {
    let valid = true
    const elms = Object.values(this.fieldRefs)

    // When the form first mounts, it won't have refs
    // It should not be valid at this point
    if (!elms.length) {
      return false
    }

    elms.forEach((elm: any) => {
      if (!elm.isValid()) {
        valid = false
      }
    })

    return valid
  }

  public attachRef = (name: string) => {
    return (elm: any) => {
      this.fieldRefs[name] = elm
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/Forms.tsx